export const statuses = {
  NO: "NO",
  PENDING: "PENDING",
  ACCEPTED: "ACCEPTED",
  DECLINED: "DECLINED",
  CANCELLED: "CANCELLED",
  BLOCKED: "BLOCKED",
  READY_TO_COMPLETE: "READY_TO_COMPLETE",
  COMPLETED: "COMPLETED",
  EXPIRED: "EXPIRED",
  PROVIDE_IN_PERSON: "PROVIDE_IN_PERSON", // READY_TO_COMPLETE with MANUAL type
  NOT_PROVIDED: "NOT_PROVIDED", // READY_TO_COMPLETE, unable to provide, OTHER
  VERIFIED: "VERIFIED", // COMPLETED, UK or Irish passport route
  UNABLE_TO_VALIDATE: "UNABLE_TO_VALIDATE",
  CHECK_CANCELLED: "CHECK_CANCELLED",
};

export const TILE_ONLY_STATUSES = [statuses.VERIFIED, statuses.NOT_PROVIDED];

export const CLOSED_REASON_STATUSES = {
  LOCKED_OUT: statuses.UNABLE_TO_VALIDATE,
  CANCELLED: statuses.CHECK_CANCELLED,
};

export const types = {
  MANUAL: "MANUAL",
};

export const documentTypes = {
  PASSPORT: "PASSPORT",
  DRIVERS_LICENSE: "DRIVERS_LICENSE",
  IDCARD: "IDCARD",
  RESIDENCE_PERMIT: "RESIDENCE_PERMIT",
};

export const iconConfig = {
  [statuses.PENDING]: {
    iconName: "dots-horizontal",
    type: "default",
    textKey: "requested",
    isPrimary: true,
  },
  [statuses.ACCEPTED]: {
    iconName: "progress",
    type: "default",
    textKey: "inProgress",
    isPrimary: true,
  },
  [statuses.BLOCKED]: {
    iconName: "attention-fill",
    type: "error",
    textKey: "potentialFraud",
    isPrimary: true,
  },
  [statuses.READY_TO_COMPLETE]: {
    iconName: "tick-circle",
    type: "success",
    textKey: "verified",
    isPrimary: true,
  },
  [statuses.DECLINED]: {
    iconName: "attention-fill",
    type: "error",
    textKey: "requestDeclined",
    isPrimary: true,
  },
  [statuses.COMPLETED]: {
    iconName: "tick-circle",
    type: "success",
    textKey: "complete",
    isPrimary: true,
  },
  [statuses.CANCELLED]: {
    iconName: "attention-fill",
    type: "warning",
    textKey: "cancelled",
    isPrimary: true,
  },
  [statuses.PROVIDE_IN_PERSON]: {
    iconName: "attention-fill",
    type: "warning",
    textKey: "provideInPerson",
    isPrimary: true,
  },
  [statuses.EXPIRED]: {
    iconName: "attention-fill",
    type: "error",
    textKey: "expired",
    isPrimary: true,
  },
  [statuses.VERIFIED]: {
    iconName: "tick-circle",
    type: "success",
    textKey: "verified",
    isPrimary: true,
  },
  [statuses.NOT_PROVIDED]: {
    iconName: "attention-fill",
    type: "warning",
    textKey: "notProvided",
    isPrimary: true,
  },
};

export const tagIconConfig = {
  ...iconConfig,
  [statuses.UNABLE_TO_VALIDATE]: {...iconConfig[statuses.EXPIRED], textKey: "unableToValidate"},
  [statuses.CHECK_CANCELLED]: {...iconConfig[statuses.EXPIRED], textKey: "cancelled"},
};

export const rightToRentConditions = {
  ALL: "ALL",
  COMPLETE: "COMPLETE",
};

export const rightToRentRequestTypes = {
  ALL: "ALL",
  COMPLETED: "COMPLETED",
};

export const UK_GOV_LINK = "https://www.gov.uk/view-right-to-rent";

export const HOME_OFFICE_REQUEST_CHECK_LINK =
  "https://www.landlords-request-a-check.homeoffice.gov.uk/";

export const DVS_REGISTER_LINK =
  "https://www.access-dvs-register.service.gov.uk/register/service-details?serviceId=276";
